export default __webpack_public_path__ + "static/media/eviatar-peretz.f8282f33.png";